module.exports = __webpack_public_path__ + "img/enrollment_bg.83d78c2c.jpg";